<template>
        <SearchLogo />
</template>
<script lang='ts'>
import { reactive, toRefs, defineComponent, onMounted} from 'vue';
import SearchLogo from './Search/SearchLogo.vue';
export default defineComponent({
    name: 'Header',
    components: {
        SearchLogo,
    },
    setup() {
        const data = reactive({
        });
        const refData = toRefs(data);
        return {
            ...refData,
        };
    },
});
</script>
<style scoped lang='scss'>
</style>
